import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { GridPanelContainerComponent } from '@components';
import { GridTileItemDirective } from '@directives';

@NgModule({
  declarations: [GridPanelContainerComponent, GridTileItemDirective],
  exports: [GridPanelContainerComponent, GridTileItemDirective],
  imports: [CommonModule, MatGridListModule],
  providers: []
})
export class GridPanelContainerModule {}
